export default "__VITE_ASSET__CXvGNxOI__"